import { render, staticRenderFns } from "./ProcedureReportPageScroll.vue?vue&type=template&id=8caf4f68&scoped=true&"
import script from "./ProcedureReportPageScroll.vue?vue&type=script&lang=js&"
export * from "./ProcedureReportPageScroll.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureReportPageScroll.vue?vue&type=style&index=0&id=8caf4f68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8caf4f68",
  null
  
)

export default component.exports